<template>
  <div class="content content--idea-single" v-if="loading">
    <MyHeader :breadcrumbItems="[

        {
          name: ideaBoardSection.value,
          path: `/${$route.params.companySlug}/ideas`
        },
        {
          name: idea.headline,
          path: $route.path
        },
      ]" />

    <header class="content-header d-lg-none">
      <h1>Idea board</h1>
      <router-link :to="{name: 'AddIdea'}" class="button-icon-simple"><i class="icon-plus"></i></router-link>
    </header>

    <div class="hero--idea">
      <div class="container">
        <div class="hero-top">
          <div class="hero-pic">
            <ImageWrapper :file="idea.idFile" :key="idea.idFile"></ImageWrapper>
          </div>
          <div class="hero-content">
            <div class="hero-content-top">
              <span class="box-tag"><span>{{idea._embedded.Category.value}}</span><span>{{ idea._embedded.Content.createdAt | timeSince('UTC', true) }}</span></span>
              <div class="box-user d-none d-lg-flex">
                <div class="box-user-img">
                  <ImageWrapper v-if="idea._embedded.User.idPicture" :file="idea._embedded.User.idPicture" :key="idea._embedded.User.idPicture"></ImageWrapper>
                  <img v-else src="../../assets/images/avatar-placeholder.png">
                </div>
                <span v-if="idea._embedded.User.lastName">{{ idea._embedded.User.firstName }} {{idea._embedded.User.lastName}}</span>
                <span v-else>{{ idea._embedded.User.email }}</span>
              </div>

              <!--<Bookmark :contentId="idea.idContent"></Bookmark>-->
            </div>

            <span class="box-title">{{ idea.headline }}</span>
          </div>
        </div>

        <div class="hero-bottom d-none d-lg-flex">
          <div v-if="idea._embedded.Content.status" class="hero-bottom-status d-none d-lg-block">
            <span class="label">Current status:</span>
            <span class="value" v-if="isOpenVoting(idea.votingDeadline) && idea._embedded.Content.status==='VOTING'">{{ idea._embedded.Content.status | capitalize }}</span>
            <span class="value" v-else-if="idea._embedded.Content.status!=='VOTING'">{{ idea._embedded.Content.status | capitalize }}</span>
            <span class="value" v-else>Closed Voting</span>

          </div>
          <div class="hero-bottom-respond">
            <template v-if="isOpenVoting(idea.votingDeadline)">
              <span v-if="voted" class="hero-thankyou">Thank you for your vote!</span>
              <button v-if="userVoted" class="button-icon" @click="toggleVote()">Unvote <i class="icon-vote-filled"></i></button>
              <button v-if="!userVoted" class="button-icon" @click="toggleVote()">Vote <i class="icon-vote-empty"></i></button>
            </template>
            <span v-if="idea.votes" class="hero-votes">
              <template v-if="idea.votes > 1">{{ idea.votes }} votes</template>
              <template v-if="idea.votes === 1">{{ idea.votes }} vote</template>
            </span>
          </div>
        </div>

        <div class="hero-bottom--mobile d-lg-none">
          <span class="label">Contributors</span>
          <div class="box-users-list">
            <div class="box-user">
              <div class="box-user-img">
                <ImageWrapper v-if="idea._embedded.User.idPicture" :file="idea._embedded.User.idPicture"></ImageWrapper>
                <img v-else src="../../assets/images/avatar-placeholder.png">
              </div>
              <span v-if="idea._embedded.User.lastName">{{ idea._embedded.User.firstName }} {{idea._embedded.User.lastName}}</span>
              <span v-else>{{ idea._embedded.User.email }}</span>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div class="mobile-respond d-lg-none">
      <div class="container">
        <template>
          <span v-if="voted">Thank you for your vote!</span>
          <button v-if="userVoted" class="button-icon" @click="toggleVote()">Unvote <i class="icon-vote-filled"></i></button>
          <button v-if="!userVoted" class="button-icon" @click="toggleVote()">Vote <i class="icon-vote-empty"></i></button>
        </template>
<!--        <template v-if="owner.id === user.id && idea.status && idea.status.name === 'Draft'">-->
<!--          <router-link :to="{name: 'EditIdea'}" class="button-icon">Edit idea</router-link>-->
<!--        </template>-->
      </div>
    </div>

    <div class="mobile-status d-lg-none" v-if="$route.name === 'IdeaOverview'">
      <div class="container">
        <span class="mobile-status-title">Current status</span>
        <IdeaStatusBox :status="lastStatus" :is-new="1"></IdeaStatusBox>
      </div>
    </div>

    <div class="tabs">
      <div class="tabs-inner">
        <router-link :to="{name: 'IdeaOverview'}" exact active-class="active" >Overview</router-link>
        <router-link :to="{name: 'IdeaStatus'}" exact active-class="active" >Status history</router-link>
      </div>
    </div>

    <router-view></router-view>
  </div>
</template>

<script>
import MyHeader from '@/components/general/Header'
import IdeaStatusBox from "@/components/ideas/IdeaStatusBox";
import api from '@/api/ideas'
import ImageWrapper from "@/components/general/ImageWrapper";
import settings from "@/settings";
import moment from "moment-timezone";
export default {
  name: "Idea",
  components: {
    ImageWrapper,
    MyHeader,
    IdeaStatusBox,
  },
  data () {
    return {
      voted: false,
      loading: false
    }
  },
  computed: {
    idea() {
      return this.$store.getters.idea
    },
    userVoted() {
      return this.idea._embedded.Votes.some((vote) => {
        return vote.idUser === this.$store.getters.user.idUser
          })
    },
    lastStatus() {
      return this.idea._embedded.Content._embedded.ContentHistory[0]
    },
    ideaBoardSection() {
      return this.$store.getters.sectionByCode(settings.MODULES.IDEA_BOARD)
    }
  },
  mounted() {
    this.getIdea()
  },
  watch: {
    '$route.params.id'() {
      this.getIdea()
      this.$nextTick(() => {
        let mainDiv = document.getElementsByClassName("content--idea-single");
        if(mainDiv) {
          mainDiv[0].scrollIntoView({behavior: 'smooth'})
        }
      })
    },
    '$store.getters.ideaLoaded'() {
      this.loading = true
      window._paq.push(['setDocumentTitle', this.idea.headline]);
      window._paq.push(['trackPageView']);
    }
  },
  methods: {
    isOpenVoting(date) {
      return Math.floor((moment(date).unix() - moment().unix())) > 0
    },
    getIdea () {
      let params = {
          _embed: 1,
          _idType: this.ideaBoardSection.idSettingCompany,
          _page: 1,
          _per_page: 1,
          idPost: this.$route.params.id
      }
      this.$store.dispatch('getIdea', params)
    },
    toggleVote () {
      this.voted = false;
      let data = {
        idUser: this.$store.getters.user.idUser,
        idContent: this.idea.idContent,
        type: 'VOTE',
        deleteReaction: this.userVoted ? 1 : null
      }
      api.addReaction(data, response => {
        this.voted = false;
        if(response.idUser) {
          this.voted = true;
        }
        this.getIdea();
      })
    }
  }
}
</script>

<style scoped>

</style>
